import Vue from 'vue';
import Router from 'vue-router';

import demoRoutes from './demo';
import nmrjRoutes from './nmrj';
import bbjRoutes from './bbj';
import circusRoutes from './circus';
import anniversary from './anniversary';
import nySign from './nySign';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/servitor',
  // routes: [
  //   ...demoRoutes,
  //   ...nmrjRoutes,
  //   ...bbjRoutes,
  //   ...circusRoutes,
  //   ...anniversary
  // ]


  routes: [
    ...demoRoutes,
    ...circusRoutes,
    ...anniversary,
    ...nySign,
    ...nmrjRoutes,
    ...bbjRoutes
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/servitor/index.js